angular.module("avlib").filter('avRelativeDate', function () {
    return function(date){
    	if (date != null){
        	var today = moment().startOf('day');
        	if (today.isSame(date, 'day')){
        		return "Hoje";
        	}else{
        		var tomorrow = moment(today).add(1, "day");
        		if (tomorrow.isSame(date, 'day')){
            		return "Amanhã";
        		}else{
        			var yesterday = moment(today).subtract(1, "day");
            		if (yesterday.isSame(date, 'day')){
                		return "Ontem";
            		}
        		}
        	}
        	return moment(date).startOf('day').from(today);
        }
    	return null;
    };
});
